import { UseMutationResult, useMutation } from 'react-query';
import { setUserNpi } from 'src/api/user';

export const setUserNpiKey = 'setUserNpi';

export interface UseSetUserNpiInputVariables {
    npi: string;
}

export const useSetUserNpi = (userId: number): UseMutationResult<void, Error, UseSetUserNpiInputVariables, unknown> => {
    return useMutation({
        mutationKey: [setUserNpiKey],
        mutationFn: async (variables) => {
            const { npi } = variables;

            if (!userId) {
                throw new Error('User id is required');
            }

            if (!npi) {
                throw new Error('NPI is required');
            }

            await setUserNpi(userId, npi);
        },
        retry: false,
    });
};
